import axios from 'axios';
import create from 'zustand';
import { ADMINAPI_BASE_URL } from "utils/base_urls"

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

const AddTaskData = async (keyword) => {
    let csrftoken = '';
    try {
        const responsecsrftoken = await axios.request({
            baseURL: ADMINAPI_BASE_URL,
            url: `/project/`
        })

        if (responsecsrftoken.status === 200) {
            csrftoken = responsecsrftoken.data;
        }
        
        let USERID = localStorage.getItem('access_token');
        keyword.IDUSER = USERID;

        const response = await axios.post(ADMINAPI_BASE_URL + '/tasking/api/addTask',
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrftoken
                },
                body: {
                    data: keyword
                },
                credentials: 'include'
            })
        
        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        return 'Error'
    }
}

const createTask = async (keyword) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/tasking/api/createTask',
            keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            }
        )
        
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return 'Error';
    }
}

const getTasks = async () => {
    try {
        const response = await axios.get(ADMINAPI_BASE_URL + '/tasking/api/getTasks',
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            }
        )

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        return 'Error'
    }
}

const deleteTask = async (id) => {
    try {
        const response = await axios.delete(ADMINAPI_BASE_URL + `/tasking/api/deleteTask/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            }
        )

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        throw error;   
    }
}

const useStore = create((set, get) => ({
    AddTask: async (keyworkd) => {
        try {
            return AddTaskData(keyworkd);
        } catch (error) {
            console.log(`Error in AddTaskData: ${error}`);
        }
    },
    createTask: async (keyword) => {
        try {
            return createTask(keyword);
        } catch (error) {
            console.log(`Error in createTask: ${error}`);
        }
    },
    getTasks: async (keyword) => {
        try {
            return getTasks(keyword);
        } catch (error) {
            console.log(`Error in getTasks: ${error}`);
        }
    },
    deleteTask: async (keyword) => {
        try {
            return deleteTask(keyword);
        } catch (error) {
            console.log(`Error in deleteTask: ${error}`);
        }
    }
}));

export default useStore;